const distributionWheel = () => {
    const pieSlices = [...document.querySelectorAll('.pie-slice')];
    if(!pieSlices) return;
    const pieSliceLabels = document.querySelector('.js-distribution-wheel-key');

    const removeActive = () => {
        const items = [...pieSliceLabels.getElementsByTagName('li')]
        items.forEach(item => {
            item.classList.remove('-active')
        })
    }

    pieSlices.forEach(slice => {
        slice.addEventListener('mouseover', (e) => {
            const targetID = e.target.dataset.pie;
            if(targetID){
                removeActive()
                const label = pieSliceLabels.querySelector(`[data-pie="${targetID}"]`)
                label.classList.add('-active')
            }
        })
    })
}
distributionWheel()
